import { useEffect, useRef } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Outlet, useNavigate } from 'react-router-dom';
import { Divider, Paper, Tab, Tabs } from '@material-ui/core';
import Grow from '@material-ui/core/Grow';
import styles from './SuperAdminMenu.module.css';
import getHeaderData from 'config/HeaderData';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, useMediaQuery } from '@mui/material';

const SuperAdminMenu = ({ match }) => {
  const { t } = useTranslation();
  const HeaderData = getHeaderData(t);
  const navigate = useNavigate();
  const uploadLoading = useSelector((state) => state.nonPersistedReducers.uploadSliceReducer.loading);

  const tabsActions = useRef();

  const desktop = useMediaQuery('(min-width: 992px)');

  useEffect(() => {
    setTimeout(() => {
      if (tabsActions?.current) {
        tabsActions.current.updateIndicator();
      }
    }, 1000);
  }, []);

  return (
    <div className={styles.root}>
      <CssBaseline />
      <Grow in={true} timeout={1000}>
        <Paper className={styles.settingsContainer}>
          <Tabs
            TabIndicatorProps={{
              style: { background: 'var(--primary-main)' }
            }}
            action={tabsActions}
            orientation='vertical'
            variant='fullWidth'
            value={
              HeaderData.options.superAdmin.find((option) => window.location.pathname.toString().includes(option.to))
                ?.to || `${match?.url}/dashboard`
            }
            className={styles.tabs}>
            {HeaderData.options.superAdmin.map((option, idx) => (
              <Tab
                selected={window.location.pathname.toString().includes(option.to)}
                value={option.to}
                disabled={option.disabled || uploadLoading}
                style={{ minWidth: '50px', minHeight: '36px', height: '36px' }}
                onClick={() => navigate(`${option.to}`)}
                icon={<Divider orientation='vertical' />}
                label={`${option.name}`}
                key={`${idx}_option_tab`}
              />
            ))}
          </Tabs>
          <Box
            sx={{
              width: desktop ? (window.location.pathname.includes('/superadmin/dashboard') ? '92%' : '100%') : '100%'
            }}>
            <Outlet />
          </Box>
        </Paper>
      </Grow>
    </div>
  );
};

export default SuperAdminMenu;
